import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Reklamationen')
    .setChildren([
        MenuEntry.create()
            .setTitle('Meine Reklamationen')
            .setRoute('claim_list_current_user'),
        MenuEntry.create()
            .setTitle('Offene Reklamationen')
            .setRoute('claim_list_open'),
        MenuEntry.create()
            .setTitle('Alle Reklamationen')
            .setRoute('claim_list')
            .setAdditionalRoutes([
                'claim_create',
                'claim_edit',
            ]),
        MenuEntry.create()
            .setTitle('Reklamation erstellen')
            .setRoute('claim_create'),
        MenuEntry.create()
            .setTitle('Minderungseinstellungen')
            .setRoute('claim_reduction_settings'),
        MenuEntry.create()
            .setRoute('claim_processing_states'),
        MenuEntry.create()
            .setTitle('Tags')
            .setRoute('claim_list_tags')
            .setAdditionalRoutes([
                'claim_tags_create',
                'claim_tags_edit',
            ]),
    ]);
